import * as M from "@discovery/prelude/lib/data/maybe";
import { cn } from "@discovery/classnames";
import { Modal } from "../../../atoms/parental-control/components/modal";
import { HeaderVariants, Tags, Typography } from "../../../atoms/typography";
import * as styles from "./styles.css";
import { Link, LinkKind } from "../../../../components/atoms/link";
import { Button, ButtonVariant } from "../../../../components/atoms/button";
import { Icon, Icons } from "../../../../components/atoms/icon";
import Strings from "../../../../utils/hardcoded.json";
export const GetInTouch = ({ onContinue }) => (React.createElement(Modal, { label: Strings.CONTACTUS },
    React.createElement("div", { className: styles.container },
        React.createElement("div", { className: styles.wrapper },
            React.createElement(Typography, { classNameM: M.of(styles.header), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                React.createElement(React.Fragment, null, Strings.ALL_ACCESS_GET_INTOUCH))),
        React.createElement("div", { className: styles.wrapper },
            React.createElement(Icon, { type: Icons.Mail, className: styles.imageStyle })),
        React.createElement("div", { className: styles.wrapper },
            React.createElement(Typography, { classNameM: M.of(styles.email), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                React.createElement(React.Fragment, null, Strings.EMAIL_ADDRESS))),
        React.createElement("div", { className: styles.wrapper },
            React.createElement(Link, { href: `mailTo:${"hello@discovery.com"}`, kind: LinkKind.external, openInNewWindow: true },
                React.createElement(Typography, { classNameM: M.of(styles.mailId), variant: HeaderVariants.headingSix, tag: Tags.h6 },
                    React.createElement(React.Fragment, null, "hello@discovery.com")))),
        React.createElement("div", { className: cn(styles.buttonWrapper, styles.wrapperTop) },
            React.createElement(Button, { children: Strings.HOME, variant: ButtonVariant.Primary, onClickM: M.of(() => onContinue()) })))));

